import React, { memo } from "react";
import BallotIcon from "@mui/icons-material/Ballot";

import { NodeCard, NodeHandle, useNodeStyles } from "./nodeKit";

export default memo(({ data, isConnectable, id }) => {
  const classes = useNodeStyles();

  return (
    <NodeCard color="#EC5858" icon={<BallotIcon />} title="Trocar Fluxo" id={id}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      <div className={`${classes.slot} ${classes.slotRow}`}>
        <BallotIcon />
        <span className={classes.ellipsis}>{data?.typebotIntegration?.message}</span>
      </div>
      <NodeHandle type="source" id="a" isConnectable={isConnectable} />
    </NodeCard>
  );
});
